export default "__VITE_ASSET__CKIPJECo__"